import { render, staticRenderFns } from "./AdminScope.vue?vue&type=template&id=310ead8c&"
import script from "./AdminScope.vue?vue&type=script&lang=ts&"
export * from "./AdminScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports